import { reaction } from 'mobx';
import { AuthenticationUsecase } from './application/usecase/AuthenticationUsecase';
import { ExclusionListUsecase } from './application/usecase/ExclusionListUsecase';
import { HistoryHandlerUsecase } from './application/usecase/HistoryHandlerUsecase';
import { KaizenLabServiceUsecase } from './application/usecase/KaizenLabServiceUsecase';
import { OrganizationUsecase } from './application/usecase/OrganizationUsecase';
import { ProjectUsecase } from './application/usecase/ProjectUsecase';
import OrganizationStore from './domain/store/OrganizationStore';
import ProjectStore from './domain/store/ProjectStore';
import UiState from './domain/store/UiState';

interface IDependencies {
  authenticationUsecase: AuthenticationUsecase;
  exclusionListUsecase: ExclusionListUsecase;
  historyHandlerUsecase: HistoryHandlerUsecase;
  kaizenLabServiceUsecase: KaizenLabServiceUsecase;
  organizationUsecase: OrganizationUsecase;
  projectUsecase: ProjectUsecase;
  organizationStore: OrganizationStore;
  projectStore: ProjectStore;
  uiState: UiState;
}

export class Application {
  private authenticationUsecase: AuthenticationUsecase;
  private exclusionListUsecase: ExclusionListUsecase;
  private historyHandlerUsecase: HistoryHandlerUsecase;
  private kaizenLabServiceUsecase: KaizenLabServiceUsecase;
  private organizationUsecase: OrganizationUsecase;
  private projectUsecase: ProjectUsecase;
  private organizationStore: OrganizationStore;
  private projectStore: ProjectStore;
  private uiState: UiState;

  constructor({
    authenticationUsecase,
    exclusionListUsecase,
    historyHandlerUsecase,
    kaizenLabServiceUsecase,
    organizationUsecase,
    projectUsecase,
    organizationStore,
    projectStore,
    uiState,
  }: IDependencies) {
    this.authenticationUsecase = authenticationUsecase;
    this.exclusionListUsecase = exclusionListUsecase;
    this.historyHandlerUsecase = historyHandlerUsecase;
    this.kaizenLabServiceUsecase = kaizenLabServiceUsecase;
    this.organizationUsecase = organizationUsecase;
    this.projectUsecase = projectUsecase;
    this.organizationStore = organizationStore;
    this.projectStore = projectStore;
    this.uiState = uiState;
  }

  public async boot() {
    const {
      authenticationUsecase,
      exclusionListUsecase,
      historyHandlerUsecase,
      kaizenLabServiceUsecase,
      organizationUsecase,
      projectUsecase,
      organizationStore,
      uiState,
    } = this;
    try {
      await authenticationUsecase.authenticate();
      await exclusionListUsecase.getExclusionLists();
      await organizationUsecase.getOrganizations();
      await projectUsecase.getProjects(organizationStore.selectedOrganizationId);
    } catch (e) {
      console.error(e);
    }
    await kaizenLabServiceUsecase.getKaizenLabServiceList(organizationStore.selectedOrganizationId);
    historyHandlerUsecase.replaceHistory(organizationStore.selectedOrganizationId);
    uiState.setReady(true);
    this.reactions();
  }

  private reactions() {
    const {
      historyHandlerUsecase,
      kaizenLabServiceUsecase,
      projectUsecase,
      organizationStore,
      projectStore,
      uiState,
    } = this;

    reaction(
      () => organizationStore.selectedOrganizationId,
      async (selectedOrganizationId: string) => {
        await kaizenLabServiceUsecase.getKaizenLabServiceList(selectedOrganizationId);
        historyHandlerUsecase.replaceHistory(selectedOrganizationId);
        try {
          await projectUsecase.getProjects(selectedOrganizationId);
        } catch (e) {
          console.error(e);
        }
      },
    );

    reaction(
      () => projectStore.isLoading,
      (isLoading: boolean) => {
        if (!isLoading) {
          uiState.setReady(true);
        } else {
          uiState.setReady(false);
        }
      },
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/Application.ts